<template lang="pug">
.compose(:id='compose_id', :class='{ minimized: minimized }')
  .full(v-show='!minimized')
    .title(:class='titleClass()')
      span {{ compose_header }}
      .close-compose(@click='close()')
        img(src='../../../assets/images/icons/fechar-compose.svg')
      .minimize-compose(@click='minimize()')
        img(src='../../../assets/images/icons/minimizar-compose.svg')
    .form
      .label-to(v-if="template.kind == 'email' || task.templateKind() == 'email'") Para
      .form-group(v-if="template.kind == 'email' || task.templateKind() == 'email'")
        input.contacts(v-if='task_has_contact' :value='task.contact.full_name', disabled='disabled')
        contact-autocomplete(v-else, :external_id='id', @contact-selected='updateContact')
        .contact-name(v-if='task_has_contact') {{ task.contact.full_name }}
          .remove-contact.glyphicon.glyphicon-remove(@click='removeContact', v-if='task.id == null')
      .cc-open(v-if="template.kind == 'email' || task.templateKind() == 'email'", @click='toggleCc') Cc
      .cc-wrapper(v-show='show_cc')
        .label-cc Cc
        .email(v-for='(item,index) in cc_emails') {{ item.email }}
          .remove-email.glyphicon.glyphicon-remove(@click='removeEmail(index)')
        input.cc(v-show='cc_emails.length < 10', v-model='cc_text', @blur='blurCc')
      .clear
      .form-group(:class="subject_group_class", v-if="template.kind == 'email' || task.templateKind() == 'email'")
        input.subject(v-model='subject',
                      placeholder='Assunto',
                      name='subject',
                      type='text',
                      v-validate="'required'",
                      @blur='updateLastSubjectCursorPosition')
        transition-group(name='fade')
          .help-block(v-show="subject_help_text", key="subject") {{ subject_help_text }}
        variables-dropdown(id='subject-variables', :class='{ cc: show_cc }', :variables="variables", @add-variable="addVariableToSubject")
      .clear
      .form-group.white-border(:class="{ 'has-error' : errors.has('body') }")
        .label-body {{ template.id? contentLabel(template.kind) : contentLabel(task.templateKind()) }}
        textarea#body.body(name='body', v-validate="'required'")
        transition-group(name='fade')
          .help-block(v-show="errors.has('body')", key="body") {{ errors.first('body') }}
        variables-dropdown(id='body-variables',
                           :variables="variables",
                           :class='{ cc: show_cc }',
                           @add-variable="addVariableToBody",
                           @mousedown.native.prevent="saveSummernoteRange")
      .form-group.white-border
        div(v-if="files.length != 0")
          div(v-for="(file, index) in files")
            div.attachment(:class="{ 'text-uploading': file.uploading }")
              div.progress-bar-upload(v-if="file.uploading" :style="{ width: file.progress + '%'}")
              span.file-name {{ file.name }}
              span ({{ file.size / 1000 }} KB)
              button.close(type='button' v-if="!file.uploading" @click='removeFile(index)')
                span ×

    .footer
      template-autocomplete(v-if='allow_change_template',
                            :external_id='id',
                            @template-selected='updateTemplate',
                            @hide='hideTemplateAutocomplete',
                            :kind='task.templateKind()')
      img.templates(src='../../../assets/images/icons/templates-compose.svg',
                    data-toggle='tooltip',
                    :title='template_name',
                    data-placement='top',
                    @click='toggleTemplateAutocomplete')
      img(src='../../../assets/images/icons/diagramacao-compose.svg', @click='toggleToolbar()')
      img(src='../../../assets/images/icons/anexo.svg'
          @click='chooseFiles()'
          v-if='files.length < 5 && current_user.isNylas() && !is_meeting_schedule')
      .btn-primary.btn.whatsapp-icon(v-if='task.isSocialTask()', :class='{ disabled: !contact_has_cellphone }', @click='toWhatsapp')
        img(src='../../../assets/images/icons/icon-whatsapp.svg', :class='{ disabled: !contact_has_cellphone }')
      .btn-primary.btn.linkedin-icon(v-if='task.isLikedinTask()', @click='toLinkedin') Copiar e Abrir Linkedin
        img(src='../../../assets/images/icons/icon-linkedin.svg')
      .btn-primary.btn.btn-send(v-if="task.templateKind() == 'email' && !is_meeting_schedule",@click='submit(true)', :disabled='loading || isUploading()') Enviar
      .btn-primary.btn(v-else-if='!copied && !is_meeting_schedule', @click='copy()') Copiar
      .btn-primary.btn(v-else-if='!is_meeting_schedule', @click='doneTask()') Finalizar
      .btn-primary.btn-calendar.btn(:class='{ scheduled: task.isScheduled() }', @click='openScheduler()' v-if="!is_meeting_schedule && task.isEmailTask()")
        img(src='../../../assets/images/icons/calendar.svg')
      .btn-primary.btn(v-if='is_meeting_schedule', @click='submit(false, true)') Agendar lembrete
      .btn-primary.btn-save.btn(@click='submit(false)', :disabled='loading || isUploading()' v-if="!is_meeting_schedule") Salvar
      input#fileUpload(ref="fileUpload" v-on:change='selectAttachment' type="file" style="display:none")
      .vertical-separator
      //- img.trash(src='../../../assets/images/icons/trash-compose.svg')
  .minimized(v-show='minimized')
    .title(:class='template.kind')
      span {{ compose_header }}
      .close-compose(@click='close()')
        img(src='../../../assets/images/icons/fechar-compose.svg')
      .minimize-compose(@click='minimize()')
        img(src='../../../assets/images/icons/maximizar-compose.svg')

  scheduler(v-if='show_scheduler',
            :task='task',
            :loading='loading',
            :number_composes = 'number_composes',
            :event='event'
            @close-scheduler='closeScheduler()',
            @schedule-meeting-date='setMeetingReminderDate'
            @schedule-email-send='handleSchedueEmailEvent')
</template>

<script>

const helpers = require('../../../helpers.coffee')
const summernote = require('../../../libraries/summernote.coffee')

const view_model = {
  props: {
    id: {
      default: "new-compose"
    },

    task: {
      default: {}
    },

    template: {
      default: {}
    },

    number_composes: {
      default: 1
    },

    event: {
      default: {}
    }
  },

  components: {
    contactAutocomplete: require('../autocomplete/contacts'),
    variablesDropdown: require('../../templates/variables_dropdown.vue'),
    templateAutocomplete: require('../autocomplete/templates'),
    scheduler: require('./scheduler')
  },

  data() {
    return {
      cc_text: '',
      cc_emails: [],
      loading: false,
      show_template_autocomplete: false,
      current_user: Session.current_user,
      lastSubjectCursorPosition: 0,
      minimized: false,
      selected_template: null,
      variables: [],
      show_cc: false,
      copied: false,
      subject: '',
      file_ids: [],
      show_scheduler: false,
      due_on_scheduler: null,
      error_file: false,
      files: [],
      uploading: false,
      progress: 0,
      progress_bar: [],
      removed_contact: null,
      remove_quota_exceeded: false,
      schedule: false,
      send_email: false
    }
  },

  methods: {
    updateMetadata(task){
      this.task.metadata = task.metadata
      this.task.due_on = task.due_on
    },
    titleClass(){
      if (this.task.isScheduled()){
        if(this.template){
          return this.template.kind + " scheduled"
        }else{
          return this.task.templateKind() + " scheduled"
        }
      }else{
        if(this.template){
          return this.template.kind
        }else{
          return this.task.templateKind()
        }
      }
    },
    openScheduler(){
      this.show_scheduler = true
    },

    closeScheduler(){
      this.show_scheduler = false
    },

    doneTask() {
      this.task.markAsDone()
      return this.tasks_resources.save(this.taskUpdated, this.unknownError, this.task.serialize(['id', 'done_at']))
    },

    taskUpdated(resources) {
      alertify.success('Tarefa atualizada com sucesso')
      resources.task.assigned_to = this.task.assigned_to
      EventsBus.$emit('Task::Done', resources.task)
      return this.close()
    },

    copy() {
      this.select(this.compose_id, 'note-editing-area')
      document.execCommand("copy")
      alertify.success('Texto copiado para a área de transferência')
      return this.copied = true
    },

    contentLabel(kind) {
      switch (kind) {
        case "email": return "Conteúdo do email"
        case "phonecall": return "Conteúdo do roteiro de ligação"
        case "linkedin": return "Conteúdo do Inmail"
        case "social": return "Conteúdo da mensagem em rede social"
        default: return "Conteúdo do email"
      }
    },

    removeEmail(index) {
      return this.cc_emails.splice(index, 1)
    },

    updateContact(contact) {
      this.task.contact = contact
      this.updateSummernoteCode()
    },

    removeContact() {
      this.removed_contact = this.task.contact
      this.task.contact = null
      this.updateSummernoteCode(this.removed_contact)
    },

    toggleTemplateAutocomplete() {
      this.show_template_autocomplete = !this.show_template_autocomplete
      if (this.show_template_autocomplete) { jQuery(`#${this.compose_id} .panel-heading.note-toolbar`).hide() }
      return this.initTooltip()
    },

    hideTemplateAutocomplete() {
      return this.show_template_autocomplete = false
    },

    updateTemplate(template) {
      this.selected_template = template
      if(this.task_has_contact){
        this.subject = this.variablesValues(template.subject, false)
      }else{
        this.subject = template.subject
      }
      this.setSummernoteCode()
    },

    toggleCc() {
      this.show_cc = !this.show_cc
      this.cc_emails = []
      return this.cc_text = ''
    },

    saveSummernoteRange() {
      return this.$body.summernote('editor.saveRange')
    },

    addVariableToSubject(data) {
      var value = data.variable.placeholder;
      if(this.task_has_contact){
        value = this.task.contact[data.variable.target_method]
      }
      return this.subject = [
        this.subject.slice(0, this.lastSubjectCursorPosition),
        value,
        this.subject.slice(this.lastSubjectCursorPosition)
      ].join('')
    },

    updateLastSubjectCursorPosition(evt) {
      return this.lastSubjectCursorPosition = evt.target.selectionStart
    },

    addVariableToBody(data) {
      this.$body.summernote('editor.restoreRange')
      this.$body.summernote('editor.focus')
      if(this.task_has_contact && this.task.contact[data.variable.target_method]){
        this.$body.summernote('pasteHTML', '<span class="'+data.variable.placeholder_name+'">'+this.task.contact[data.variable.target_method]+'</span>')
      }else{
        this.$body.summernote('insertText', data.variable.placeholder)
      }
    },

    loadVariables() {
      params = { company_id: Session.current_company.id }
      return new VariableResource().index(this.loadVariablesSuccess, null, {params})
    },

    loadVariablesSuccess(resource) {
      this.variables = resource.variables
      this.setSummernoteCode()
    },

    handleSchedueEmailEvent(due_on){
      this.due_on_scheduler = due_on
      this.submit(false, true)
    },

    setMeetingReminderDate(reminder_date) {
      this.due_on_scheduler = reminder_date
    },

    submit(send_email, schedule) {
      if (send_email == null) { send_email = false }
      if (schedule == null) { schedule = false }
      this.send_email = send_email
      this.schedule = schedule
      if (this.loading) { return }
      this.blurCc()
      if(this.task.contact != null && this.task.contact.id) {
        this.setTemplate()
        return this.$validator.validateAll(this.selected_template).then(success => {

          if (Session.current_user.isNylas()) {
            if (Session.current_user.nylas_setting.quota_exceeded != null && !this.remove_quota_exceeded && this.send_email) {
              return this.quotaExceeded()

            }
          }

          return this.validateVariables(send_email, schedule)
        })
      } else {
        return alertify.error("Por favor, selecione o contato.")
      }
    },

    chooseFiles() {
      this.$refs.fileUpload.click()
    },

    selectAttachment() {
      let file = event.target.files[0]
      this.files.push(file)
      this.error_file = false
      if(file.size > 20971520) {
        this.error_file = true
        return alertify.error("ERRO. O anexo deve possuir no máximo 20 MB.")
      }

      this.uploading = true
      file.uploading = true
      file.progress = 0
      var formData = new FormData();
      formData.append('file', file);
      jQuery.ajax({
        url: process.env.NYLAS_URL + '/files',
        data: formData,
        type: 'POST',
        contentType: false,
        processData: false,
        headers: {
          'authorization': 'Basic ' + btoa(Session.current_user.nylas_setting.access_token +':')
        },
        success: this.uploadDone,
        error: this.uploadError
      })
    },

    uploadDone(data) {
      this.file_ids = this.file_ids.concat(data.map(element => { return element.id }))
      let file = this.files.find(file => { return file.name == data[0].filename })
      file.uploading = false;
      file.progress = 100;
      this.error_file = false
      this.$refs.fileUpload.value = ''
      this.$forceUpdate()
    },

    uploadError(error) {
      this.file_ids = []
      this.files = []
      this.error_file = true
    },

    removeFile(index) {
      this.file_ids.splice(index, 1)
      this.files.splice(index, 1)
      this.$refs.fileUpload.value = ''
    },

    validateVariables(send_email, schedule) {
      this.loading = true
      const templates_resource = new TemplatesResource(Session.current_company.id)
      return templates_resource.validate(this.emitValidationSuccess(send_email, schedule), this.handleApiErrors, this.selected_template)
    },

    emitValidationSuccess(send_email, schedule) {
      const event = { originalEventName: 'validation-success' }
      return this.saveTemplateAndSendEmail(send_email, schedule)
    },

    close() {
      return this.$emit('compose-close')
    },

    minimize() {
      return this.minimized = !this.minimized
    },

    toggleToolbar() {
      return jQuery(`#${this.compose_id} .panel-heading.note-toolbar`).toggle()
    },

    inializeSummernote() {
      var self = this
      this.$body = jQuery(`#${this.compose_id} .form .body`)
      summernote(this.$body, {scroll: false})
      jQuery('.compose').on('summernote.change', function(we, contents, $editable) {

        if(self.task_has_contact) {

          var body = self.$body.summernote('code')
          body = self.variablesPlaceholder(body, self.task.contact)

          for(let variable of self.variables) {
            if( body.indexOf('<span class="' + variable.placeholder_name) > -1 ) {
              let remove_var = body.indexOf('<span class="' + variable.placeholder_name + '">' + self.task.contact[variable.target_method]) == -1
              if (remove_var) {
                let parts = body.split('<span class="' + variable.placeholder_name)

                while(parts[1].indexOf('</span>') != 0) {
                  parts[1] = parts[1].substr(1);
                }

                parts[1] = parts[1].substr(7)

                body = self.variablesValues(parts[0] + parts[1])
                self.$body.summernote('code', body)
                return;
              } else {
                // content values only variable value
                let parts = body.split('<span class="' + variable.placeholder_name + '">' + self.task.contact[variable.target_method])
                let extra_content = ''

                while(parts[1].indexOf('</span>') != 0) {
                  extra_content = extra_content + "" + parts[1]
                  parts[1] = parts[1].substr(1);
                }

                parts[1] = parts[1].substr(7)

                let tmp = ''
                extra_content = extra_content.split('</span>')[0]
                tmp = '<span class="'+variable.placeholder_name+'">'+self.task.contact[variable.target_method]+'</span>' + extra_content

                parts[1] = tmp + parts[1]

                body = self.variablesValues(parts[0] + parts[1])
                self.$body.summernote('code', body)
                return;
              }
            }
          }
        }
      })
    },

    setTemplate() {
      if (!this.task.service === 'ManualTasksServices::Email') { this.subject = '-' }
      if (!this.selected_template.name) { this.selected_template.name = "-" }
      var body = this.$body.summernote('code')
      if(this.task_has_contact){
        this.selected_template.subject = this.variablesPlaceholder(this.subject, this.task.contact, false)
        body = this.variablesPlaceholder(body, this.task.contact)
      } else {
        this.selected_template.subject = this.subject
      }
      this.selected_template.body = body !== '<p><br></p>' ? body : ''
      return this.task.template = this.selected_template
    },

    updateSummernoteCode(contact) {
      var body = this.$body.summernote('code')
      if(this.task_has_contact) {
        body = this.variablesValues(body)
        this.subject = this.variablesValues(this.subject, false)
      }else{
        body = this.variablesPlaceholder(body, contact)
        this.subject = this.variablesPlaceholder(this.subject, contact, false)
      }
      this.$body.summernote('code', body)
    },

    setSummernoteCode() {
      var body =  this.selected_template && this.selected_template.body ? this.selected_template.body : ''
      if(this.task_has_contact) {
        body = this.variablesValues(body)
        this.subject = this.variablesValues(this.subject, false)
      }
      this.$body.summernote('code', body)
    },

    variablesValues(text, html=true) {
      this.variables.forEach(variable => {
        if(this.task.contact[variable.target_method] && text){
          if(html){
            // text = text.replace(variable.placeholder, '<span class="'+variable.placeholder_name+'">'+this.task.contact[variable.target_method]+'</span>')
            text = text.split(variable.placeholder).join('<span class="'+variable.placeholder_name+'">'+this.removeSpecialCharacter(this.task.contact[variable.target_method])+'</span>')
          }else{
            // text = text.replace(variable.placeholder, this.task.contact[variable.target_method])
            text = text.split(variable.placeholder).join(this.task.contact[variable.target_method])
          }
        }
      })
      return text
    },

    variablesPlaceholder(text, contact, html=true) {
      this.variables.forEach(variable => {
        if(text && contact[variable.target_method]){
          if(html){
            // text = text.replace('<span class="'+variable.placeholder_name+'">'+contact[variable.target_method]+'</span>', variable.placeholder)
            text = text.split('<span class="'+variable.placeholder_name+'">'+this.removeSpecialCharacter(contact[variable.target_method])+'</span>').join(variable.placeholder)
          }else{
            // text = text.replace(contact[variable.target_method], variable.placeholder)
            text = text.split(contact[variable.target_method]).join(variable.placeholder)
          }
        }
      })
      return text
    },

    removeSpecialCharacter(text){
      var result = text.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;")
      return result
    },

    initTooltip() {
      if (this.selected_template.name) { jQuery('[data-toggle="tooltip"]').tooltip('destroy') }
      return jQuery('[data-toggle="tooltip"]').tooltip()
    },

    blurCc() {
      const last_index = this.cc_text.length - 1
      if ((this.cc_text[last_index] === ',') || (this.cc_text[last_index] === '') || (this.cc_text[last_index] === ' ')) { return }
      return this.cc_text += " "
    },

    setParams(send_email,schedule) {
      if (send_email == null) { send_email = false }
      const shared_params = {
        subject: this.selected_template.subject,
        body: this.selected_template.body,
        kind: this.selected_template.kind,
        file_ids: this.file_ids,
        send_email,
        remove_quota_exceeded: this.remove_quota_exceeded
      }

      if (this.cc_emails.length > 0) {
        shared_params.cc = this.cc_emails
      }

      // Task created by flow
      let params = {
        id: this.task.id,
        task_id: this.task.id,
        signature: this.selected_template.signature
      }

      // Task created by user
      if (this.task != null && (this.task.isCreatedByUser() || this.task.isOzzyTask())) {
        params = {
          task_id: this.task.id,
          template_id: this.selected_template.id
        }
      }

      // No task
      if (this.task.id === null) {
        this.task.slug = 'email-task'
        params = {
          contact_id: this.task.contact.id,
          template_id: this.selected_template.id
        }
      }

      // if scheduler was called
      if (schedule) {
        params['due_on'] = this.due_on_scheduler
      }

      return Object.assign({}, params, shared_params)
    },

    scheduleEmailSend(params){
      this.loading = true
      this.tasks_resources.schedule(this.scheduleEmailSendSuccess,this.scheduleEmailSendFailure, params)
    },

    scheduleEmailSendSuccess(data){
      this.loading = false
      alertify.success("Tarefa de envio de email agendada com sucesso.")
      if(data.task.isDueToday()){
        EventsBus.$emit('Task::UpdatedMetadata', data.task)
      }else{
        EventsBus.$emit('Task::remove', data.task)
      }
      this.updateMetadata(data.task)
      this.closeScheduler()
      this.close()
    },

    scheduleEmailSendFailure(){
      this.loading = false
      alertify.error("Ops, ocorreu algum erro ao agendar o envio do email.")
    },

    saveTemplateAndSendEmail(send_email, schedule) {
      const params = this.setParams(send_email, schedule)
      const success_callback = send_email ? this.sendEmailSuccess : this.saveTemplateSuccess
      if(schedule){
        return this.scheduleEmailSend(params)
      }
      if (this.task == null || this.task.id === null || this.task.isCreatedByUser() || this.task.isOzzyTask()) {
        return this.tasks_resources.only_send_email(success_callback, this.sendEmailFailure, params)
      } else {
        return this.tasks_resources.save_template_and_send_email(success_callback, this.sendEmailFailure, params)
      }
    },

    sendEmailFailure(data) {
      this.loading = false
      this.unknownError()
    },

    sendEmailSuccess(data) {
      this.loading = false
      alertify.success('E-mail disparado com sucesso')
      this.task.markAsDone()
      if (this.task.id) { EventsBus.$emit('Task::Done', this.task) }
      return this.close()
    },

    saveTemplateSuccess(response) {
      this.loading = false
      alertify.success('Template salvo com sucesso')
      EventsBus.$emit('Task::Undone', response.task)
      return this.close()
    },

    hideCompose() {
      this.setTemplate()
      return this.$emit('compose-hide', this.task)
    },

    isUploading() {
      for(let file of this.files) {
        if(file.uploading) return true
      }
      return false
    },

    quotaExceeded() {
      EventsBus.$emit('quota-exceeded-modal')
    },

    removeQuotaExceeded() {
      this.remove_quota_exceeded = true
      this.submit(this.send_email, this.schedule)
    },

    toWhatsapp() {
      if(!this.task_has_contact || !this.task.contact.cellphone) return ''
      let cellphone = this.task.contact.cellphone
      cellphone = '55' + cellphone.replace(/[^0-9+]+/ig, "")
      let contents = this.$body.summernote('code');
      let body = contents.replace(/<\/p>/gi, "\n")
                         .replace(/<br\/?>/gi, "\n")
                         .replace(/<\/?[^>]+(>|$)/g, "")
                         .replace(/&nbsp;/gi, ' ')
                         .replace(/%26nbsp%3B/gi, ' ')
      body = encodeURIComponent(body).replace(/&nbsp;/gi, ' ').replace(/%26nbsp%3B/gi, ' ')
      let url = `https://web.whatsapp.com/send?phone=${cellphone}&text=${body}`
      window.open(url, '_blank')
    },

    toLinkedin() {
      this.copy()
      let absolute_url = 'https://www.linkedin.com/'
      if(this.task.contact.linkedin) {
        let url = this.task.contact.linkedin
        let reg = /^((http|https|ftp):\/\/)/
        if(!reg.test(url)) {
          absolute_url = "http://" + url
        }
        else {
          absolute_url = url
        }
      }
      window.open(absolute_url, '_blank')
    }
  },

  watch: {
    cc_text(text) {
      const last_index = text.length - 1
      if ((text[last_index] === ',') || (text[last_index] === '') || (text[last_index] === ' ')) {
         const email = text.substring(0, last_index)
         if (this.validateEmail(email)) {
           this.cc_emails.push({ email })
           return this.cc_text = ''
         }
       }
    },
    uploading() {
      if(this.uploading) {
        this.progress = 0
        var self = this
        for(let i = 0; i < 90; i++) {
          this.progress_bar.push(setTimeout(() => {
              self.progress = i
          }, i * 200))
        }
      }
    }
  },

  computed: {
    contact_has_cellphone() {
      if(!this.task_has_contact || !this.task.contact.cellphone) return false
      return true
    },

    task_has_contact() {
      return (this.task.contact != null ? this.task.contact.id : undefined)
    },

    scheduled_overdue() {
      if(this.task.id){
        return this.task.isOverdue() && this.task.isScheduled()
      }else{
        return false
      }
    },

    allow_change_template() {
      return this.show_template_autocomplete
    },

    template_name() {
      return (this.selected_template != null ? this.selected_template.name : undefined)
    },

    compose_id() {
      return `compose-${this.id}`
    },

    subject_group_class() {
      if (this.errors.has('subject')) {
        return 'has-error'
      } else if (this.subject) {
        if (this.subject.length > 60) {
          return 'has-danger'
        } else if (this.subject.length > 40) {
          return 'has-warning'
        }
      }
    },

    subject_help_text() {
      if (this.errors.has('subject')) {
        return this.errors.first('subject')
      } else if (this.subject) {
        if (this.subject.length > 60) {
          return 'Assuntos acima de 60 caracteres não aparecerão completos para os seus leads'
        } else if (this.subject.length > 40) {
          return 'Assuntos acima de 40 caracteres podem ser cortados'
        }
      }
    },

    compose_header() {
      if(this.is_meeting_schedule) {
        return 'Agendar e-mail de lembrete de reunião'
      }

      if ((this.task.contact != null ? this.task.contact.id : undefined)) {
        return (this.task.contact != null ? this.task.contact.full_name : undefined) + ' - ' + __guard__(this.task.contact != null ? this.task.contact.business : undefined, x => x.name)
      } else {
        return 'Novo E-mail'
      }
    },

    is_meeting_schedule() {
      if (event){
        return event.originalEventName == 'Compose::Open::Schedule::Meeting'
      }
    }
  },

  mounted() {
    this.inializeSummernote()
    this.setSummernoteCode()
    if (this.selected_template.name) { this.initTooltip() }

    if(this.is_meeting_schedule) {
      this.openScheduler()
      this.toggleCc()
    }
    return this.errors.clear()
  },

  created() {
    this.tasks_resources = new TasksResource
    this.selected_template = this.template
    this.subject = this.selected_template.subject
    if(this.selected_template.cc)
      if(this.selected_template.cc.length > 0) {
        this.cc_emails = this.selected_template.cc.map(item => { return { email: item } })
        this.show_cc = true
      }
    EventsBus.$on('send-email-quota-exceeded', this.removeQuotaExceeded)
    return this.loadVariables()
  },

  beforeDestroy() {
    this.$body.summernote('destroy')
    EventsBus.$off('send-email-quota-exceeded', this.removeQuotaExceeded)
    return this.hideCompose()
  },

  updated() {
    return this.initTooltip()
  }
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)
function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}

</script>

<style lang="sass" scoped>
@import "../../../assets/stylesheets/_variables.sass"

.compose
  position: fixed
  width: 480px
  border-radius: 4px
  background-color: #ffffff
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5)
  bottom: 5px
  z-index: 1041

  .label-to, .label-cc
    position: absolute
    z-index: 1
    top: 8.5px
    left: 8.5px
    font-size: 11px
    font-weight: 500
    font-style: normal
    font-stretch: normal
    line-height: normal
    letter-spacing: normal
    text-align: left
    color: #8c98a1

  .label-cc
    top: 42px

  .dropdown-menu
    top: auto

  .label-body
    font-size: 11px
    font-weight: 500
    font-style: normal
    font-stretch: normal
    line-height: normal
    letter-spacing: normal
    text-align: left
    color: #8c98a1
    padding: 8.5px

  .contact-name
    top: 6px
    left: 38.5px
    z-index: 1
    position: absolute
    border-radius: 2px
    background-color: #6c7c88
    padding: 2px 4px
    font-size: 11px
    font-weight: 500
    color: white

    .remove-contact
      margin-left: 10px
      cursor: pointer
      font-size: 10px

  .cc-open
    cursor: pointer
    position: absolute
    top: 11px
    right: 10px
    font-size: 11px
    font-weight: 500
    color: #576876

  #subject-variables, #body-variables
    position: absolute
    font-size: 9px
    width: 65px
    right: 5px

  #subject-variables, #body-variables
    top: 10px

  .minimized
    .title
      border-radius: 5px
      // width: 200px
  .title
    border-radius: 4px 4px 0 0
    background-color: #434343
    font-size: 12px
    font-weight: 500
    font-style: normal
    font-stretch: normal
    line-height: normal
    letter-spacing: normal
    text-align: left
    color: #ffffff
    padding: 8px
    min-height: 32px

    &.email
      background-color: #3290e8
    &.social
      background-color: #a9ec78
    &.phonecall
      background-color: #f5a623
    &.linkedin
      background-color: #0077a0

    .close-compose, .minimize-compose
      float: right
      margin-left: 10px
      cursor: pointer

  .form
    position: relative
    .help-block
      position: absolute
      top: 16px
      z-index: 1
      float: left
      margin-left: 9px
      font-size: 10px

    .form-group
      position: relative
      margin-bottom: 0

      &.has-error
        border-top: none !important

        input.contacts, input.subject,
          border-bottom: 1px solid #a94442

        &.has-danger
          color: #f2780c!important

        &.has-warning
          color: #ffcc02!important

    input.subject
      padding: 8.5px 75px 8.5px 8.5px !important

    input.subject::placeholder,
    input.cc::placeholder
      font-weight: 500
      color: #8c98a1

    input.contacts, input.subject, input.cc
      width: 100%
      float: left
      border: none
      border-bottom: 1px solid #e2e2e2
      padding: 8.5px
      padding-left: 38.5px
      font-size: 11px
      font-weight: 100
      text-align: left
      color: #000
      outline: none

    input.cc
      padding-left: 0
      width: auto
      border: none

  .footer
    float: left
    width: 100%
    padding: 6px 5.5px
    border-top: solid 1px #e2e2e2
    background-color: #f9f9f9

    .btn-save
      background-color: $button-blue
      margin-right: 6px
      border-radius: 1px

      &:hover
        background-color: darken($button-blue, 20%)

    .vertical-separator
      float: right
      width: 1px
      margin-right: 12px
      height: 23px
      margin-top: 2px
      margin-left: 7px
      background: #e2e2e2

    img
      margin-top: 6px
      margin-right: 5px
      margin-left: 6px
      cursor: pointer

      &.templates
        float: left

      &.trash
        float: right

    .btn
      float: right
      padding: 5px 12px
      font-size: 11px

    .linkedin-icon
      padding: 5px 6px
      margin-right: 5px
      margin-left: 6px
      display: inline-block
      text-align: center
      vertical-align: middle

      img
        padding: 0px
        margin: 0 0 0 4px
        width: 15px
        height: 15px

    .whatsapp-icon
      padding: 5px 6px
      margin-right: 5px
      margin-left: 6px
      display: inline-block
      text-align: center
      vertical-align: middle

      img
        padding: 0px
        margin: 0px

    .disabled
      cursor: not-allowed

// CC
.cc-wrapper
  float: left
  width: 100%
  border-bottom: 1px solid #e2e2e2
  padding-left: 31px
  .email
    float: left
    border-radius: 2px
    background-color: #6c7c88
    padding: 2px 4px
    font-size: 11px
    font-weight: 500
    color: white
    margin-right: 8px
    margin-top: 6px

    &:last-child
      margin-bottom: 6px

    .remove-email
      margin-left: 10px
      cursor: pointer
      font-size: 10px

.btn-calendar
  background-color: $button-blue
  width: 25px
  height: 25px
  margin-right: 6px
  margin-left: -5px
  border-radius: 1px
  padding: 0 !important

  img
    margin: 0 !important
    margin-top: 7.5px !important

  &:hover
    background-color: darken($button-blue, 20%)

.btn-send
  border-radius: 1px

.scheduled
  background-color: $scheduled-overdue-orange !important

.attachment-button
  border-radius: 1px
  margin-right: 6px

.light-grey
  background-color: $reev-base-green

.progress-bar-upload
  background-color: $reev-base-green
  position: absolute
  z-index: -99
  left: 10px
  top: 0px
  position: absolute
  z-index: -99
  height: 100%

.attachment
  font-size: 12px
  border: 1px solid lightgray
  margin: 10px
  padding: 8px
  color: $reev-base-green

  .file-name
    font-weight: bold

  .close
    font-weight: bold

.attachment.text-uploading
  color: black
</style>



// WEBPACK FOOTER //
// list_item.vue?d9db7480